module.exports = __webpack_public_path__ + "img/error-data.6751d8c0.svg";